(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvBsbInput', drvBsbInput);
        
    drvBsbInput.$inject = [];

        /**
         * @ngdoc directive
         * @name drvBsbInput
         * @description Bsb input which includes validation.
         *
         * @param {string} value - Bsb
         * @param {object} field - An entity field object
         */
    function drvBsbInput() {
            drvBsbInputCtrl.$inject = ['$q', 'FieldTypesService'];

            return  {
                templateUrl: 'app/fieldinput/bsb-input.tmpl.html',
                require: "ngModel",
                scope: {
                },
                controller: drvBsbInputCtrl,
                controllerAs: 'drvCtrl',
                bindToController: {
                    value: '=ngModel',
                    field: '='
                },
                link: link
            };

            function drvBsbInputCtrl($q, FieldTypesService) {
                /* jshint validthis:true */
                var drvCtrl = this;
                drvCtrl.validateBsb = validateBsb;
                drvCtrl.bsbDescription = null;

                /*
                 * Check to see if the Bsb is valid
                 */
                function validateBsb(bsb) {
                    if (!_.isNil(bsb) && bsb !== '') {
                        if (bsb.length == 6 && !isNaN(bsb)) {
                            return FieldTypesService.getBsbDescription(bsb)
                                .then(getBsbDescriptionOk);
                        } else {
                            drvCtrl.bsbDescription = null;
                            return $q.reject();
                        }
                    } else {
                        drvCtrl.bsbDescription = null;
                        return $q.when(true);
                    }

                    function getBsbDescriptionOk(data) {
                        drvCtrl.bsbDescription = data;

                        if (!_.isNil(data) && data !== '') {
                            return $.when(true);
                        } else {
                            return $q.reject();
                        }
                    }
                }
            }
        }

        /*
         * Link function which will handle validation
         */
        function link($scope, $element, $attrs, $ctrl) {
            $scope.pni[$scope.drvCtrl.field.Name].$asyncValidators.formatValid = function required(modelValue, viewValue) {
                return $scope.drvCtrl.validateBsb(modelValue);
            };
        }
})();